import React from 'react';
import Logo from 'common/Components/Logo';
import Layout from 'common/Layouts';
import { Form } from './Components/Form';
import { useTranslation } from 'react-i18next';

export const DesktopSetPassword = () => {
  const { t } = useTranslation();


  const getTitle = () => {
    const pageName = t(`FormSide.ResetPasswordText`);
    const brokerName = t(`BrokerCode_${window.api?.BROKER_CODE}.Title`);
    const separateSymbol = ' - ';
    return pageName + separateSymbol + brokerName;
  };

  return (
    <Layout strech title={getTitle()}>
      <div className="mt-1">
        <Logo />
        <h1 className="text-4xl xl:text-5xl my-4 !font-bold  text-center text-L-primary-50">
          {t(`FormSide.ResetPasswordText`)}
        </h1>
      </div>
      <Form />
    </Layout>
  );
};
